import {
  Button,
  message,
  Modal,
  Dropdown,
  Avatar,
  Space,
  Typography,
  Tooltip,
  Tag,
} from "antd";
import {
  UserOutlined,
  MenuUnfoldOutlined,
  LogoutOutlined,
  ReloadOutlined,
  KeyOutlined,
  SafetyOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl, GET_BY_ID, HEADERS_EXPORT, VERSION } from "../API/apiUrls";
import { COLOR } from "../../utils/theme";
import "../../assets/styles/Header.css";

const { Text } = Typography;

const Header = ({ title, onPress }) => {
  const navigate = useNavigate();
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const userName = localStorage.getItem("USERNAME");
  const fullName = `${localStorage.getItem("FNAME") || ""} ${
    localStorage.getItem("LNAME") || ""
  }`;

  const loadData = async () => {
    try {
      const res = await axios.get(baseUrl + GET_BY_ID + userId, {
        headers: HEADERS_EXPORT,
      });
      if (res.data && res.status === 200) {
        localStorage.setItem("USER_ID", res.data?.id);
        // ... (เซ็ตค่าอื่นๆ ตามเดิมของคุณ)
        message.success("รีโหลดข้อมูลใหม่สำเร็จ");
        window.location.reload();
      }
    } catch (error) {
      message.error("ไม่สามารถรีโหลดข้อมูลได้");
    }
  };

  const signOut = () => {
    localStorage.clear(); // เคลียร์ทั้งหมดเพื่อความปลอดภัย
    message.success("ออกจากระบบสำเร็จ");
    navigate("/");
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  const menuItems = [
    {
      key: "profile-info",
      label: (
        <div style={{ padding: "8px 0" }}>
          <Space>
            <Avatar
              size={40}
              icon={<UserOutlined />}
              style={{
                background: `linear-gradient(135deg, ${COLOR.secondaryLight} 0%, ${COLOR.secondary} 100%)`,
                color: COLOR.primary,
              }}
            />
            <div>
              <div
                style={{ fontWeight: 600, fontSize: 14, color: COLOR.primary }}
              >
                {fullName.trim() || userName}
              </div>
              <div style={{ color: "#999", fontSize: 12 }}>@{userName}</div>
            </div>
          </Space>
        </div>
      ),
      disabled: true,
    },
    { type: "divider" },
    {
      key: "viewProfile",
      label: "โปรไฟล์",
      icon: <UserOutlined />,
      onClick: () => navigate("/profile"),
    },
    {
      key: "changePassword",
      label: "เปลี่ยนรหัสผ่าน",
      icon: <KeyOutlined />,
      onClick: () => navigate("/chang-password"),
    },
    { type: "divider" },
    {
      key: "logout",
      label: "ออกจากระบบ",
      icon: <LogoutOutlined />,
      danger: true,
      onClick: () => {
        Modal.confirm({
          title: "ยืนยันการออกจากระบบ",
          content: "คุณต้องการออกจากระบบหรือไม่?",
          centered: true,
          okText: "ออกจากระบบ",
          cancelText: "ปิด",
          okType: "danger",
          onOk: signOut,
        });
      },
    },
  ];

  return (
    <header
      style={{
        background: "#fff",
        padding: "0 24px",
        height: 64,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        position: "sticky",
        top: 0,
        zIndex: 100,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 16,
          flex: 1,
          minWidth: 0,
        }}
      >
        <Tooltip title="เปิด/ปิดเมนู">
          <Button
            type="text"
            icon={
              <MenuUnfoldOutlined
                style={{ fontSize: 20, color: COLOR.secondary }}
              />
            }
            onClick={onPress}
            style={{
              width: 40,
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        </Tooltip>

        <div style={{ flex: 1, minWidth: 0 }}>
          <Text
            strong
            className="header-title-text"
            style={{
              fontSize: 18,
              // 1. ลบหรือ Comment บรรทัด background ไล่เฉดสีออก
              // background: `linear-gradient(135deg, ${COLOR.secondaryLight} 0%, ${COLOR.secondary} 100%)`,

              // 2. กำหนด WebkitTextFillColor เป็นสีที่ต้องการ (ในที่นี้คือดำ)
              WebkitBackgroundClip: "unset", // ยกเลิกการ Clip ข้อความ
              WebkitTextFillColor: "black", // กำหนดสีตัวอักษรสำหรับ Browser ตระกูล Webkit

              // 3. ใส่สีดำปกติเพื่อรองรับ Browser อื่นๆ
              color: "black",

              display: "block",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {title}
          </Text>
        </div>
      </div>

      <Space size="middle">
        <Tag
          className="version-badge"
          style={{
            padding: "4px 12px",
            background: `${COLOR.secondaryLight}20`,
            borderRadius: 20,
            border: `1px solid ${COLOR.secondaryLight}`,
          }}
        >
          <Space size={4}>
            <SafetyOutlined style={{ color: "green", fontSize: 24 }} />
            <Text
              style={{ fontSize: 12, color: COLOR.secondary, fontWeight: 500 }}
            >
              {VERSION}
            </Text>
          </Space>
        </Tag>

        <Tooltip title="รีโหลดข้อมูล">
          <ReloadOutlined
            onClick={loadData}
            style={{ fontSize: 18, color: COLOR.secondary, cursor: "pointer" }}
          />
        </Tooltip>

        <Dropdown
          menu={{ items: menuItems }}
          trigger={["click"]}
          placement="bottomRight"
          arrow
        >
          <div
            className="header-user-dropdown"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              cursor: "pointer",
              padding: "4px 12px",
              borderRadius: 20,
            }}
          >
            <Avatar
              size={36}
              icon={<UserOutlined />}
              style={{
                background: `linear-gradient(135deg, ${COLOR.secondaryLight} 0%, ${COLOR.secondary} 100%)`,
                color: COLOR.primary,
              }}
            />
            <div
              className="user-info"
              style={{
                display: "flex",
                flexDirection: "column",
                lineHeight: 1.2,
              }}
            >
              <Text strong style={{ fontSize: 14, color: COLOR.primary }}>
                {userName}
              </Text>
              <Text type="secondary" style={{ fontSize: 11 }}>
                ผู้ใช้งาน
              </Text>
            </div>
          </div>
        </Dropdown>
      </Space>
    </header>
  );
};

export default Header;
